import React, { useState, useEffect } from 'react';
import ViewPastGiftPage from './components/viewPastGiftPage';
import CustomLayout from '@/common/Layout';
import { TabTitle } from '../../utilities/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { getPastGiftsList } from './redux/slice';

function ViewPastGift() {
  TabTitle('Gift Register - View Gift Status');

  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const {
    pastGiftsList,
    pagination,
    pastGiftsListLoading,
    CountsPastGiftsList
  } = useSelector((state) => state.pastGifts);
  const [radiofilter, setRadiofilter] = useState(
    JSON?.parse(window.localStorage.getItem('set_Radiofilter')) === null
      ? ''
      : JSON?.parse(window.localStorage.getItem('set_Radiofilter'))
  );
  const [triggerFilter, setTriggerFilter] = useState(false);
  const [searchRequest, setSearchRequest] = useState('');
  const [isSwitch, setIsSwitch] = useState(true);

  //console.log('CountsPastGiftsList', CountsPastGiftsList);
  console.log(triggerFilter);
  console.log('pastGiftsList', pastGiftsList);

  useEffect(() => {
    handleGetPastGiftsList();
  }, [page, pageSize]);
  useEffect(() => {
    if (triggerFilter) {
      if (page === 1) {
        handleGetPastGiftsList();
      } else {
        setPage(1);
      }
    }
  }, [radiofilter, searchRequest, isSwitch]); //page,

  const handleGetPastGiftsList = () => {
    let payload = {
      page,
      per_page: pageSize,
      status: radiofilter,
      search: searchRequest,
      delegation_type: isSwitch === true ? 'self' : 'delegated'
    };
    dispatch(getPastGiftsList(payload));
  };

  console.log('setIsSwitch', isSwitch);

  const onChange = () => {
    setTriggerFilter(true);
    setIsSwitch(!isSwitch);
    // window.localStorage.setItem('set_Toogle', JSON?.stringify(!isSwitch));
  };

  /* const handleChange = (e) => {
    const value = { search: e.target.value, page, status: radiofilter };
    dispatch(searchvalues(value));
  }; */

  return (
    <CustomLayout>
      <div style={{ marginTop: '50px' }}>
        <ViewPastGiftPage
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          radiofilter={radiofilter}
          setRadiofilter={setRadiofilter}
          setTriggerFilter={setTriggerFilter}
          pastGiftsList={pastGiftsList}
          pagination={pagination}
          pastGiftsListLoading={pastGiftsListLoading}
          CountsPastGiftsList={CountsPastGiftsList}
          setSearchRequest={setSearchRequest}
          onChange={onChange}
        />
      </div>
    </CustomLayout>
  );
}
export default ViewPastGift;
